import React, { createContext, useEffect, useState } from "react";

import APIClient from "web_modules/APIClient";
import Spinner from "web_modules/shared/Spinner";

import { ILoanType } from "./interfaces";

const getLoanTypes = async (): Promise<ILoanType[]> => {
  return APIClient.get<{ loan_types: ILoanType[] }>("/cm/loan_types").then(
    ({ loan_types }) => loan_types,
  );
};

export const LoanTypesContext = createContext({
  loanTypes: [] as ILoanType[],
});

const LoanTypesProvider = ({ children }) => {
  const [loanTypes, setLoanTypes] = useState<ILoanType[]>([]);

  const init = async () => {
    const types = await getLoanTypes();
    setLoanTypes(types);
  };

  useEffect(() => {
    init().catch(e => {
      window.alert("There was a problem initializing this page! Please contact eng.");
      throw e;
    });
  }, []);

  if (!loanTypes.length) {
    return <Spinner active />;
  }

  return <LoanTypesContext.Provider value={{ loanTypes }}>{children}</LoanTypesContext.Provider>;
};

export default LoanTypesProvider;
